import { Injectable } from "@angular/core";

import { ServiceBase } from "../servicebase";
import { HttpService } from "../http.service";
import { environment } from "../../../environments/environment";
import { ApplicantDocumentModel } from "services/models/hiring/applicantDocument.model";
import { ApplicantDocumentsDownloadModel } from "services/models/hiring/applicantDocumentsDownload.model";
import { ResultBaseModel } from "services/models/result-base.model";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class ApplicantDocumentService extends ServiceBase<ApplicantDocumentModel> {
  constructor(http: HttpService) {
    super("applicantdocument", http, environment.apiUrl);
  }

  createEntity(input: any): ApplicantDocumentModel {
    return ApplicantDocumentModel.create(input);
  }

  getFile(id: string) {
    return this.http.get(`${this.endpoint}/s3-file/${id}`, null, null, null, true).pipe(
      map((res) => {
        return res;
      })
    );
  }

  downloadFile(id: string, docTitle: string) {
    return this.http.get(`${this.endpoint}/s3-file/download/${id}`, { params: { docTitle } }, null, null, true).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllApprovedFiles(applicantId: string): Observable<ResultBaseModel<ApplicantDocumentsDownloadModel>> {
    return this.http.get(
      `${this.endpoint}/get-approved-files/${applicantId}`,
      null,
      null,
      null,
      true
    ).pipe(
      map((res) => ResultBaseModel.create(res?.body ?? {}, ApplicantDocumentsDownloadModel))
    );
  }

  changeDocumentStatus(form: any): Observable<any> {
    return new Observable<any>((observer) => {
      this.http
        .post(`${this.endpoint}/document-status`, form)
        .subscribe((res) => {
          observer.next(res);
          observer.complete();
        });
    });
  }
}
